module.exports = __webpack_public_path__ + "img/preview_ards.1862f549.png";